import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\CountElectronicSignatureByStatusController::__invoke
* @see app/Http/Controllers/ElectronicSignature/CountElectronicSignatureByStatusController.php
* @route '/api/electronic-signature/count'
*/
const CountElectronicSignatureByStatusController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CountElectronicSignatureByStatusController.url(options),
    method: 'get',
})

CountElectronicSignatureByStatusController.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/count',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\CountElectronicSignatureByStatusController::__invoke
* @see app/Http/Controllers/ElectronicSignature/CountElectronicSignatureByStatusController.php
* @route '/api/electronic-signature/count'
*/
CountElectronicSignatureByStatusController.url = (options?: RouteQueryOptions) => {
    return CountElectronicSignatureByStatusController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\CountElectronicSignatureByStatusController::__invoke
* @see app/Http/Controllers/ElectronicSignature/CountElectronicSignatureByStatusController.php
* @route '/api/electronic-signature/count'
*/
CountElectronicSignatureByStatusController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CountElectronicSignatureByStatusController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\CountElectronicSignatureByStatusController::__invoke
* @see app/Http/Controllers/ElectronicSignature/CountElectronicSignatureByStatusController.php
* @route '/api/electronic-signature/count'
*/
CountElectronicSignatureByStatusController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CountElectronicSignatureByStatusController.url(options),
    method: 'head',
})

export default CountElectronicSignatureByStatusController